<template>
  <div class="product__image-carousel">
    <!-- swiper -->
    <div class="product__image-carousel-main">
      <swiper
        ref="imageCarouselSwiper"
        :options="swiperOption"
        @slideChange="slideChanged()"
      >
        <swiper-slide
          v-for="image in images"
          :key="image.id"
        >
          <div class="product__image-carousel__image-container">
            <img
              v-lazy="image.urls.large || image.urls.full"
              class="product__image-carousel__image"
              :srcset="image.srcset"
              alt=""
              @click="toggleFullScreenMode()"
            >
            <button
              class="product__image-carousel__zoom-button"
              @click="toggleFullScreenMode()"
            >
              <span class="screen-reader-text">Avaa suurempana</span>
            </button>
          </div>
        </swiper-slide>

        <button
          v-if="images.length > 1"
          slot="button-prev"
          class="swiper-button-prev"
        />
        <button
          v-if="images.length > 1"
          slot="button-next"
          class="swiper-button-next"
        />
      </swiper>
    </div>

    <div
      v-if="images.length > 1"
      class="product__image-carousel-pagination"
    >
      <swiper
        ref="paginationSwiper"
        :options="paginationSwiperOptions"
      >
        <swiper-slide
          v-for="(image, index) in images"
          :key="image.id"
          :class="{ 'active-pagination-slide': index == activePaginationSlide }"
        >
          <div class="product__image-carousel-pagination__slide product__image-carousel__image-container">
            <img
              v-lazy="image.urls.mini"
              class="product__image-carousel__image"
              :srcset="image.urls.mini + ' 1x, ' + image.urls['mini-x2'] + ' 2x'"
              alt=""
              @click="changeSlide(index)"
            >
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div
      v-show="fullScreenMode"
      class="product-image-modal"
    >
      <div class="product-image-modal__content">
        <swiper
          ref="fullScreenSwiper"
          :options="swiperOption"
          @slideChange="slideChanged()"
        >
          <swiper-slide
            v-for="image in images"
            :key="image.id"
          >
            <div class="product__image-carousel__image-container">
              <img
                v-lazy="image.urls['fullscreen-med'] || image.urls.full"
                class="product-image-modal__image"
                :srcset="image.srcset"
                alt=""
              >
            </div>
          </swiper-slide>

          <button
            v-if="images.length > 1"
            slot="button-prev"
            class="swiper-button-prev"
          />
          <button
            v-if="images.length > 1"
            slot="button-next"
            class="swiper-button-next"
          />
        </swiper>
      </div>

      <button
        class="product-image-modal__close-button"
        @click="toggleFullScreenMode()"
      >
        <span class="product-image-modal__close-button__text">Sulje</span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        images: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 0,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
            },

            paginationSwiperOptions: {
                slidesPerView: 7,
                slidesPerGroup: 1,
                spaceBetween: 16,
                allowTouchMove: false,
                centeredSlides: true,
                breakpoints: {
                    1600: {
                        slidesPerView: 5,
                    },
                    500: {
                        slidesPerView: 4,
                    },
                    400: {
                        slidesPerView: 3,
                    },
                },
            },

            activePaginationSlide: 0,
            fullScreenMode: false,
        }
    },

    computed: {
        swiper() {
            return this.$refs.imageCarouselSwiper.swiper
        },

        paginationSwiper() {
            return this.$refs.paginationSwiper.swiper
        },

        fullScreenSwiper() {
            return this.$refs.fullScreenSwiper.swiper
        },
    },

    mounted() {
        this.swiper.update();
    },

    methods: {
        slideChanged() {
            this.activePaginationSlide = this.swiper.activeIndex;
            this.paginationSwiper.slideTo(this.swiper.activeIndex);
        },

        changeSlide(index) {
            this.swiper.slideTo(index);
            this.activePaginationSlide = index;
        },

        toggleFullScreenMode() {
            this.fullScreenSwiper.slideTo(this.swiper.activeIndex);
            this.fullScreenMode = !this.fullScreenMode;
        },

    },
}
</script>
